import React from 'react';
import '@coreui/icons/css/coreui-icons.min.css';
import 'flag-icon-css/css/flag-icon.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'simple-line-icons/css/simple-line-icons.css';
import './scss/style.css';
import 'material-components-web/dist/material-components-web.min.css';

import { BrowserRouter } from 'react-router-dom';
import { DefaultLayout } from './containers';
import withAuthentication from '../src/hoc/session/withAuthentication';
import { Offline, Online } from 'react-detect-offline';
import Internet from './components/Internet';
const App = () => {
  return (
    <div>
      <Online>
        <BrowserRouter>
          <DefaultLayout />
        </BrowserRouter>
      </Online>
      <Offline>
        <Internet isOpen={true}/>
      </Offline>
    </div>
  );
};

export default withAuthentication(App);



// WEBPACK FOOTER //
// ./src/App.js